import { makeAutoObservable } from 'mobx';
import { LimitsApiResponse } from '../../api/GroupApi';

export enum EnabledFeatures {
  CROSS_CURRENCY = 'different_base_currencies',
  ONE_SIDED_FIXES = 'post_one_sided_fixes',
  ARAP = 'ar_ap_matching',
  FX_INTEREST = 'fx_interest',
  DOWNLOAD_REPORTS = 'download_reports',
  CUSTOM_RECHARGES = 'custom_recharge_periods',
  TRANSACTION_GROUPING = 'post_by_transaction_or_rule',
  MULTIPLE_LOANS = 'multiple_loans_per_entity',
  INVOICE_BILL = 'invoice_bill',
}

export class Limits {
  isLimited: boolean = false;
  isRuleLimited: boolean = false;
  isReachingRuleLimit: boolean = false;
  regularAllowance: number = 0;
  carriedOverAllowance: number = 0;
  ruleAllowance: number = 0;
  usedRules: number = 0;
  allowance: number = 0;
  used: number = 0;
  enabledFeatures: EnabledFeatures[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: LimitsApiResponse): Limits {
    const limits = new Limits();

    limits.isLimited = apiData.limited;
    limits.isRuleLimited = apiData.rulesLimited;
    limits.regularAllowance = apiData.totalMonthlyAllowance;
    limits.carriedOverAllowance = apiData.totalCarriedOverAllowance;
    limits.allowance =
      apiData.totalMonthlyAllowance + apiData.totalCarriedOverAllowance;
    limits.used = apiData.usedMonthlyAllowance;

    limits.ruleAllowance = apiData.totalRuleAllowance;
    limits.usedRules = apiData.usedRules;
    // 75% warning threshold for used rules, floored to a whole number
    //  e.g allowance of 3 and 2 used rules.
    //      threshold = 3*0.75 = 2.25 becomes 2
    //      isReachingRuleLimit = true
    const threshold = Math.floor(limits.ruleAllowance * 0.75);
    limits.isReachingRuleLimit = limits.usedRules >= threshold;
    limits.enabledFeatures = apiData.enabledFeatures;

    return limits;
  }

  get remaining(): number {
    return this.allowance - this.used;
  }

  get rulesRemaining(): number {
    return this.ruleAllowance - this.usedRules;
  }
}
